import { MenuItem } from "./menu.model";

// Menú exclusivo del rol super_admin (panel de administración de FuturaPro
// como plataforma, separado por completo del menú de cada empresa/tenant —
// ver sidebar.component.ts:aplicarMenuSegunRol). Todos los ítems son
// implícitamente solo-super_admin porque este array nunca se combina con
// el MENU de tenant.
export const MENU_PLATAFORMA: MenuItem[] = [
    {
        id: 1000,
        label: 'SIDEBAR.PLATAFORMA_TITULO',
        isTitle: true
    },
    {
        id: 1005,
        label: 'SIDEBAR.INICIO',
        icon: 'ph-squares-four',
        link: '/plataforma/inicio',
    },
    {
        id: 1010,
        label: 'SIDEBAR.EMPRESAS',
        icon: 'ph-buildings',
        link: '/plataforma/empresas',
    },
    {
        id: 1020,
        label: 'SIDEBAR.PLANES',
        icon: 'ph-stack',
        link: '/plataforma/planes',
    },
    {
        id: 1022,
        label: 'SIDEBAR.CATALOGO_GASTOS',
        icon: 'ph-tag',
        link: '/plataforma/catalogo-gastos',
    },
    {
        id: 1025,
        label: 'SIDEBAR.CUENTAS_COBRO',
        icon: 'ph-bank',
        link: '/plataforma/cuentas-cobro',
    },
    {
        id: 1030,
        label: 'SIDEBAR.FACTURAS',
        icon: 'ph-receipt',
        link: '/plataforma/facturas',
    },
    {
        id: 1040,
        label: 'SIDEBAR.ERRORES',
        icon: 'ph-warning-octagon',
        link: '/plataforma/errores',
    },
    {
        id: 1050,
        label: 'SIDEBAR.SOPORTE',
        icon: 'ph-lifebuoy',
        link: '/plataforma/soporte',
    },
]
